<!-- eslint-disable max-len -->
<template>
  <div class="advisor-card">
    <div class="advisor-avatar">
      <img
        v-if="firmInfo && firmInfo.logo"
        :src="firmInfo.logo"
        :alt="advisorName + ' avatar'"
        class="advisor-image"
      >
      <img
        v-else
        src="data:image/svg+xml,%3csvg width='100' height='100' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100' height='100' fill='%23e2e8f0'/%3e%3ctext x='50%25' y='50%25' font-size='40' fill='%2364748b' text-anchor='middle' dominant-baseline='middle'%3e👤%3c/text%3e%3c/svg%3e"
        alt="Advisor avatar"
        class="advisor-image"
      >
    </div>
    <div class="advisor-details">
      <div class="advisor-name">
        {{ advisorName }}
      </div>
      <div class="advisor-title">
        Your Financial Advisor
      </div>
    </div>
  </div>
</template>

<script>
import { computed } from 'vue';

export default {
  name: 'AdvisorCard',
  props: {
    advisorInfo: {
      type: Object,
      required: false,
      default: null,
    },
    firmInfo: {
      type: Object,
      required: false,
      default: null,
    },
  },
  setup(props) {
    const advisorName = computed(() => {
      return props.advisorInfo?.name || '';
    });

    return {
      advisorName,
    };
  },
};
</script>

<style scoped>
.advisor-card {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  flex-shrink: 0;
}

.advisor-avatar {
  width: 40px;
  height: 40px;
  flex-shrink: 0;
}

.advisor-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 9999px;
}

.advisor-details {
  color: var(--stk-text-normal);
  flex: 1;
  line-height: 1.375;
}

.advisor-name {
  font-weight: 500;
  color: var(--stk-text-strong);
  font-size: 0.875em;
}

.advisor-title {
  font-size: 0.75em;
}
</style>
